import {Link} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export type Li = {
    isInFocus: boolean
    showSelectionHighlight: boolean
}

export const Li = styled("li", {
    shouldForwardProp: p => p !== "isInFocus" && p !== "showSelectionHighlight",
})<Li>`
    /* Always reserve space for borders to prevent size changes */
    border-left: 0.25rem solid transparent;
    border-top: 0.063rem solid transparent;
    border-bottom: 0.063rem solid transparent;
    border-right: 0.063rem solid transparent;
    margin-right: -0.063rem;

    a {
        width: 100%;
        color: ${({theme}) => theme.uxfabric.components.link.inherit.enabled.textColor};
        text-decoration: none;
        padding: 0.4375rem 0;
        display: inline-block;
        font-size: ${({theme}) => theme.uxfabric.global.body3.fontSize};
        font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight};
        letter-spacing: ${({theme}) => theme.uxfabric.global.body3.letterSpacing};
        line-height: ${({theme}) => theme.uxfabric.global.body3.lineHeight};
        text-transform: ${({theme}) => theme.uxfabric.global.body3.textTransform};

        > span:first-of-type {
            text-transform: capitalize;
        }

        &:hover {
            text-decoration: underline;
        }
    }
    @media (min-width: ${breakpoints.values.md}px) {
        ${({isInFocus, showSelectionHighlight, theme}) =>
            showSelectionHighlight && isInFocus
                ? `
            background: ${theme.uxfabric.components.menu.searchMenu.enriched.backgroundColor};
            border-left-color: ${theme.uxfabric.primary.main};
            border-top-color: ${theme.uxfabric.components.menu.searchMenu.default.borderColor};
            border-bottom-color: ${theme.uxfabric.components.menu.searchMenu.default.borderColor};
            border-right-color: ${theme.uxfabric.components.menu.searchMenu.enriched.backgroundColor};
            a {
                text-decoration: none;
            }
            
        `
                : ``}
    }
`
export const Ul = styled("ul")`
    margin: 0;
    padding: 0;
    list-style: none;
`

export const AutoCompleteLink = styled(Link)(({theme}) => ({
    "&:hover": {
        color: theme.uxfabric.components.link.inherit.enabled.textColor,
    },
}))
